import { Guid } from "guid-typescript";
import { ServiceContract } from "src/app/interfaces/Index";
import { Service } from "./Service";

const endpoint = "ServiceContract";
export const ServiceContractService = {
	endpoint,
	createSingle: async (data: ServiceContract) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: ServiceContract) => await Service.updateSingleById(endpoint, id, data),
}